import React from 'react';
import PropTypes from 'prop-types';
import { Button, App } from 'antd';
import useRefreshFlightOrder from '../../../hooks/flight/useRefreshFlightOrder';

function Refresh({ refCode = '' }) {
    const { handleRefresh, refreshing } = useRefreshFlightOrder();
    const { message } = App.useApp();

    if (!refCode) {
        return null;
    }
    const onRefresh = (refCode) => {
        console.log(`Refreshing order: ${refCode}`);
        handleRefresh(refCode)
            .then((data) => {
                const reply = data.reply;
                if (reply) {
                    message?.success(reply);
                }
            })
            .catch((error) => {
                console.error('Error refreshing flight order:', error);
                message?.error(error.message);
            });
    };

    return (
        <Button
            type="link"
            loading={refreshing}
            style={{ padding: 0 }}
            onClick={() => onRefresh(refCode)}
            aria-label={`刷新订单 ${refCode}`}
        >
            刷新
        </Button>
    );
}

Refresh.propTypes = {
    refCode: PropTypes.string.isRequired,
};

export default Refresh;
